import { canRead, canWrite } from '../access/rbacAccess'

export const ORDERS = {
  LIST: 'ejecuta.orders'
}

export const canViewOrders = () => canRead(ORDERS.LIST)

export const canManageOrders = () => canWrite(ORDERS.LIST)
